import { render, staticRenderFns } from "./AttendingUsersTable.vue?vue&type=template&id=2a8defec&scoped=true&"
import script from "./AttendingUsersTable.vue?vue&type=script&lang=js&"
export * from "./AttendingUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8defec",
  null
  
)

export default component.exports